import React from 'react';
import { FaCar } from 'react-icons/fa';

const BookingBanner = () => {
  return (
    <section className="px-4 sm:px-6 lg:px-8 py-12 min-h-screen flex items-center">
      <div className="mx-auto w-full">
        <div
          // Replaced the old class with new Tailwind classes for a reliable hover effect
          className="bg-slate-800 rounded-3xl relative overflow-hidden w-full bg-blend-soft-light transition-shadow duration-300 ease-in-out hover:shadow-[0_0_50px_10px_rgba(251,191,36,0.5)]"
          style={{ backgroundImage: "url('/assets/bmw-3.png')", backgroundSize: 'cover', backgroundPosition: 'center' }}
        >
          <div className="relative z-10 max-w-lg text-white bg-black bg-opacity-70 p-12 md:p-24 lg:p-32 rounded-xl">
            <h2 className="text-3xl font-bold mb-3">
              Looking for a car?
            </h2>
            <p className="text-4xl font-bold text-white mb-4">
              +537 547-6401
            </p>
            <p className="text-slate-400 mb-8">
              Amet cras hac orci lacus. Faucibus ipsum arcu lectus nibh sapien bibendum ullamcorper in...
            </p>
            <a
              href="#"
              className="bg-amber-400 text-slate-950 font-bold py-3 px-6 rounded-lg hover:bg-amber-500 transition duration-300"
            >
              Book now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BookingBanner;